import React from 'react';
import { Box } from '@fiverr-private/theme';

// The offset is needed to match the UI properly.
// It's a temporary solution until Penta adds support for "Tag with Image" variation.
// Details: https://github.com/fiverr/penta_sphinx/issues/598

const SIZE = 24;
const OFFSET = 6;

type SkillImageProps = Readonly<{
    src: string;
}>;

export const SkillImage = ({ src }: SkillImageProps) => (
    <Box position="relative" width={SIZE - OFFSET} height={SIZE}>
        <Box
            as="img"
            src={src}
            position="relative"
            width={SIZE}
            height={SIZE}
            left={-OFFSET}
            boxSizing="borderBox"
            borderColor="border"
            borderRadius="circle"
            borderStyle="solid"
            borderWidth="sm"
            // It's recommended to always have "alt" attribute for images.
            // But for decorative ones, it has to be empty.
            // Details:
            // - https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/alt#decorative_images
            // - https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/presentation_role
            alt=""
            role="presentation"
        />
    </Box>
);
